import script from "./SideMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideMenu.vue?vue&type=script&setup=true&lang=ts"

import "./SideMenu.vue?vue&type=style&index=0&id=87e5c7fe&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87e5c7fe"]])

export default __exports__